import type { TierRequired } from "./types";

export const PATREON_CONNECT_URL = "/auth/patreon/start";
export const PATREON_JOIN_URL = "https://www.patreon.com/join/YaoiGen";

const PATREON_ORIGIN = "https://www.patreon.com";

export function safePatreonPostHref(postId?: string | null) {
  const clean = String(postId || "").trim();
  if (!/^\d{3,}$/.test(clean)) return "";
  return [PATREON_ORIGIN, "posts", clean].join("/");
}

export function safePatreonPostDisplay(postId?: string | null) {
  const clean = String(postId || "").trim();
  return /^\d{3,}$/.test(clean) ? `/posts/${clean}` : "";
}

export function joinLabelForTier(_tier: TierRequired | "all_paid" | "progressive" | "platinum_early" | undefined) {
  return "Join Patreon";
}

export function upgradeLabelForTier(tier: TierRequired | "all_paid" | "progressive" | "platinum_early" | undefined) {
  if (tier === "platinum" || tier === "platinum_early") return "Upgrade to Platinum on Patreon";
  if (tier === "paid" || tier === "all_paid" || tier === "progressive") return "Upgrade on Patreon";
  return "Join Patreon";
}
